import { initializeApp, getApps } from "firebase/app";
import { getAuth, OAuthProvider, onIdTokenChanged, signInWithPopup, signOut } from "firebase/auth";
import authConfig from "./authConfig";
import { persistSession, clearSession } from "./session";

function getFirebaseAuth() {
  return getAuth(getApps()[0] || initializeApp(authConfig.firebase));
}

function mapUser(user) {
  if (!user) {
    return null;
  }
  return {
    uid: user.uid,
    email: user.email || "",
    displayName: user.displayName || user.email || "",
  };
}

function signIn() {
  return signInWithPopup(getFirebaseAuth(), new OAuthProvider(authConfig.entraProviderId));
}

/** Firebase renueva solo el ID token si está por vencer. */
function getAccessToken(forceRefresh = false) {
  const user = getFirebaseAuth().currentUser;
  return user ? user.getIdToken(forceRefresh) : Promise.resolve(null);
}

/** Avisa cada vez que cambia la sesión (login, logout, token renovado). */
function watchSession(onChange) {
  return onIdTokenChanged(getFirebaseAuth(), (user) => {
    const profile = mapUser(user);
    if (profile) {
      persistSession(profile);
    } else {
      clearSession();
    }
    onChange(profile);
  });
}

async function logout() {
  clearSession();
  await signOut(getFirebaseAuth());
  if (authConfig.postLogoutRedirectUri) {
    window.location.replace(authConfig.postLogoutRedirectUri);
  }
}

const firebaseAdapter = {
  signIn,
  getAccessToken,
  watchSession,
  logout,
};

export default firebaseAdapter;
